import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import * as box from '../../../../../assets/zemplin/box-solid.svg';
import { round } from '../../../../utilities';
import { IconType, SvgIcon } from '../../General/SvgIcon';

interface Props {
  value: number | null;
  currency: string;
}

function FreeDeliveryBox({ value, currency = '€' }: Props) {
  const isFree = value === 0;

  if (value === null) {
    return null;
  }

  return (
    <ValueRow>
      <IconWrapper>
        {isFree ? (
          <SvgIcon
            width={40}
            height={40}
            icon={IconType.freeDel}
            viewBox="0 0 48 48"
            marginRight={8}
            alt="Doprava zdarma"
            title="Doprava zdarma"
          />
        ) : (
          <Circle percentage={value} />
        )}
      </IconWrapper>
      {!isFree ? (
        <Value>
          {__('Nakúpte ešte za')}{' '}
          <InfoPrice>{`${round(value, 2)} ${currency}`}</InfoPrice>{' '}
          {__('a dopravu máte zadarmo')}
        </Value>
      ) : (
        <Value>
          {__('Dopravu máte')}{' '}
          <InfoPrice color="#339933">{__('zadarmo')}</InfoPrice>
        </Value>
      )}
    </ValueRow>
  );
}

function Circle({ percentage }: { percentage: number }) {
  return (
    <CircleWrapper>
      <CircleInside />
    </CircleWrapper>
  );
}

const CircleInside = styled.div`
  position: relative;
  top: 2px;
  left: 2px;
  text-align: center;
  width: ${rem(36)};
  height: ${rem(36)};
  border-radius: 100%;
  background-color: #ffffff;
`;

const CircleWrapper = styled.div`
  position: relative;
  text-align: center;
  width: ${rem(40)};
  height: ${rem(40)};
  border-radius: 100%;
  background-color: #e53b3b;
  background: linear-gradient(270deg, #2cc5b7 50%, transparent 50%),
    linear-gradient(0deg, #2cc5b7 50%, lightgray 50%);
`;

const IconWrapper = styled('div')`
  display: inline-block;
  max-width: 20%;
  padding: 0 0 0 10px;
`;
const InfoPrice = styled(FlexRowCenterVertical)<{
  borderBottom?: boolean;
  color: string;
}>`
  display: inline;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
`;

const ValueRow = styled(FlexRowCenterVertical)<{ borderBottom?: boolean }>`
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${rem(16)};
  padding: ${rem(16)};
  border: 1px solid #ccc;
  justify-content: center;
  margin-top: ${rem(8)};
  font-family: ${({ theme }) => theme.font.primary};
  border-radius: ${rem(4)};
`;

const Value = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  max-width: 85%;
  margin-left: ${rem(16)};
  color: black;
  font-family: ${({ theme }) => theme.font.primary};
  text-align: left !important;
`;

export { FreeDeliveryBox };
